import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from 'react-router-dom';
import FooterFrontaliere from './subscription/form/frontaliere/Footer';
import NavbarFrontaliere from './subscription/form/frontaliere/Navbar';

export default function LayoutFrontaliere() {
  return (
    <Stack
      sx={{
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#FFEFE8 !important',
      }}
    >
      <Toolbar />
      <NavbarFrontaliere />
      <Outlet />
      <FooterFrontaliere />
    </Stack>
  );
}
